/* @flow */
import { Map } from 'immutable';
import {
  FETCH_ALL,
  FETCH_ANALYSIS,
  SAVE_ANALYSIS,
  UPDATE_ANALYSIS,
  SHARE_ANALYSIS,
  DELETE_ANALYSIS,
  SET_DISPLAY_OPTIONS,
} from './action-types.js';

export const fetchAll = () => ({ type: FETCH_ALL });

export const create = (analysis: any, graph: any) => ({
  type: SAVE_ANALYSIS,
  payload: { analysis, graph }
});

export const update = (analysis: Map<any, any>, graph: any): Object => ({
  type: UPDATE_ANALYSIS,
  payload: { analysis, graph }
});

export const share = (analysis: any) => ({
  type: SHARE_ANALYSIS,
  payload: analysis
});

export const deleteAnalysis = (guid: string) => ({
  type: DELETE_ANALYSIS,
  payload: guid,
});

export const setAnalysisDisplayOptions = (options: any) => ({
  type: SET_DISPLAY_OPTIONS,
  payload: options,
});

export const fetchAndStoreById = (id: string) => ({
  type: FETCH_ANALYSIS,
  payload: id,
});



// WEBPACK FOOTER //
// ./src/app/modules/analysis/actions.js